import { useNavigate } from 'react-router-dom'
import { useChartConnect } from '@chartapi/react-connect'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { customerData } from '../../../utilities/CustomerData'

export function DashboardChartInstantCalculation({ setIsChartInstantCalc }) {
  const navigate = useNavigate()
  const idmeHelpLink = 'https://help.id.me/hc/en-us/articles/202673924-Creating-your-ID-me-account'

  const onSuccess = ({ code }) => setCode(code)
  const onError = ({ errorMessage }) => setShowError(true)
  const onClose = () => console.log('User exited Chart Connect')

  const { open } = useChartConnect({
    clientId: process.env.REACT_APP_CHART_CLIENT_ID,
    flow: 'full-irs-online-account',
    zIndex: 999,
    sandbox: false,
    onSuccess,
    onError,
    onClose
  })
  const [code, setCode] = useState('')
  const [sendingChartCode, setSendingChartCode] = useState(false)
  const [showError, setShowError] = useState(false)
  const [showPopup, setShowPopup] = useState(false)


  useEffect(() => {
    const handleUploadChartCode = async () => {
      setSendingChartCode(true)

      const chartAccessTokenResponse = await fetch(`${apiURL}/api/uploadChartCode?contactId=${encodeURIComponent(customerData.customerLeadData.leadContact.contactId)}&code=${encodeURIComponent(code)}&isAuth=${encodeURIComponent(0)}&isReconnect=${encodeURIComponent(0)}`)
      const chartAccessTokenData = await chartAccessTokenResponse.json()
      setSendingChartCode(false)

      if (chartAccessTokenData.response.error) {
        console.error(chartAccessTokenData.response.error)
        setShowError(true)
      } else {
        customerData.customerLeadData.leadContact.chartInstantAccessToken = '1'
        setShowPopup(true)
      }
    }

    if (code)
      handleUploadChartCode()
  }, [code])

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false)
      }, 5000)
    }
  }, [showError])

  return (
    <div className='shadow-full rounded-xl p-6 lg:w-full w-11/12 h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
      <div className='w-full flex flex-col items-center'>
        <div className='flex flex-col items-center gap-4'>
          <p className='text-3xl font-bold'>Login to IRS</p>
          <button 
            disabled={sendingChartCode} 
            onClick={() => open()} 
            className={`w-full p-4 rounded-lg text-3xl font-bold shadow-md flex flex-col items-center text-white ${sendingChartCode ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200'}`}>
            <div className='flex flex-col items-center gap-2'>
              <p>Login</p>
              <p className='text-lg'>Click Here</p>
            </div>
          </button>
          <div className='bg-white p-4 rounded-md shadow-md w-full'>
            <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/zbo3195cm1?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <p className='italic text-gray-300 text-sm'>* Your ID.me credentials are the same used to login to your IRS.gov account. If you do not have an ID.me account, setting one up is simple and takes just a few minutes. For any questions on setting up your account with ID.me, please see <span onClick={() => window.innerWidth <= 768 ? window.location.href = idmeHelpLink : window.open(idmeHelpLink, '_blank')} className='cursor-pointer underline text-blue-600'>ID.me</span> for detailed account creation instructions.</p>
          {sendingChartCode && (
            <div className='flex flex-row items-center justify-center gap-2 -mb-5'>
              <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
              <p>Grabbing IRS Data, Please Wait...</p>
            </div>
          )}
          {showError && (
            <p>Oops! We ran into an issue while trying to log in to your IRS account. Please try again in about 10 minutes. Thanks for your patience! <span className='font-bold'>Please note that your application is still in process.</span></p>
          )}
        </div>
      </div>
      {showPopup && (
        <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
          <div className='bg-white p-6 rounded-lg shadow-lg text-center'>
            <p className='font-bold text-lg'>Calculation is underway</p>
            <p>Your refund amount is being calculated. This process may require up to 5 minutes. Thank you for waiting.</p>
            <button onClick={() => setIsChartInstantCalc(false)} className='mt-4 px-4 py-2 bg-primaryColor text-white rounded-lg hover:bg-primaryDarkColor transition duration-200'>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  )
}